import React from "react";
import { string } from "prop-types";

import { AdSlot } from "../../rows/ad-free";

import "./sticky-banner.m.css";

const StickyBanner = () => {
  return (
    <div styleName="wrapper">
      <div styleName="banner">
        <AdSlot id="stickey" type="mobile" />
      </div>
    </div>
  );
};

StickyBanner.propTypes = {
  pageType: string,
};

export default StickyBanner;
